import { get_translations } from "@pdfking/workflow/utils/make_translations"
import prompt from "./prompt"

export default (message?: string): Promise<boolean> =>
  get_translations("actions")
    .then(actions =>
      prompt({
        buttons: {
          abort: actions.ABORT,
          continue: actions.CONTINUE,
        },
        default_button: "continue",
        title: message || actions.ARE_YOU_SURE,
      })
    )
    .then(({ result }) => result === "continue")
